const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const Modal = require("./Modal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const WonkyButton = require("./WonkyButton");
const AssetsUtil = require("../util/AssetsUtil");
const {buttonTypeList} = require("../util/WonkyButtonUtil");

const styles = require("./styles/ModalGeneral.css");

module.exports = createReactClass({
	displayName: "MessageModalView",

	propTypes: {
		styleType: PT.string,
		size: PT.oneOf([
			"small",
			"medium",
			"large",
			"extra-large",
			"extra-extra-large",
			"text-generic",
		]),
		onClose: PT.func,
		cannotClose: PT.bool,
		hasCloseButton: PT.bool,
		levelType: PT.string,
		title: PT.string,
		modalClass: PT.string,
		backdropClass: PT.string,
		portalContainer: PT.any, // null for no gateway, string for a gateway name other than message
		buttonType: PT.oneOf(buttonTypeList),
		buttonText: PT.string,
		disableMessageFilter: PT.bool,
		buttonClickHandler: PT.func,
	},

	getDefaultProps: function() {
		return {
			portalContainer: PORTAL_CONTAINERS.TRAINER_MESSAGE,
			levelType: "default",
		};
	},

	handleClose: function() {
		this.props.onClose();
	},

	render: function() {
		const {
			size,
			children,
			title,
			styleType,
			levelType,
			portalContainer,
			buttonType,
			buttonClickHandler,
			buttonText,
			cannotClose,
			hasCloseButton,
		} = this.props;
		let modalClass = this.props.disableMessageFilter
			? styles.messageNoFilter
			: styles.message;
		if (this.props.modalClass) modalClass += " " + this.props.modalClass;
		let backdropClass = styles.backdrop;
		if (this.props.backdropClass)
			backdropClass += " " + this.props.backdropClass;
		let sizeClass;
		if (size) {
			//If a size was provided, use it.
			sizeClass = styles[size];
		} else {
			//Otherwise, default to medium and check for long text.
			sizeClass = styles.medium;
			if (_.isString(children) && children.length > 140) {
				//if text is longer than 140 characters long
				sizeClass = styles["extra-large"];
			}
		}
		if (!this.props.modalClass) {
			modalClass += " " + sizeClass;
		}

		const bgSrc = styleType && AssetsUtil.getConfirmModal(styleType);
		const bgEl = bgSrc ? (
			<img className={styles.bg} src={AssetsUtil.getConfirmModal(styleType)} />
		) : null;

		if (styleType) {
			modalClass += " " + styles[styleType];
		}

		let modalTitle = null;
		if (title) {
			modalTitle = (
				<div className={styles.titleContainer}>
					<div className={styles.title}>{title}</div>
				</div>
			);
		}

		let button = null;
		if (buttonType) {
			button = (
				<div className={styles.buttons}>
					<WonkyButton
						handleClick={buttonClickHandler || this.handleClose}
						buttonType={buttonType}
						buttonText={buttonText}
					/>
				</div>
			);
		}

		return (
			<div>
				<Modal
					portalContainer={portalContainer}
					onClose={this.handleClose}
					closeOnBackdropClick={!cannotClose}
					closeOnEsc={!cannotClose}
					hasCloseButton={!cannotClose || hasCloseButton}
					backdropClass={backdropClass}
					modalClass={modalClass}
					levelType={levelType}
				>
					{bgEl}
					{children}
					{modalTitle}
					{button}
				</Modal>
			</div>
		);
	},
});
